import { useState, useEffect, useCallback } from 'react';
import { alertApi } from '../api/client';

export function useAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAlerts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await alertApi.list();
      setAlerts(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to fetch alerts');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAlerts();
  }, [fetchAlerts]);

  const createAlert = async (data) => {
    try {
      await alertApi.create(data);
      fetchAlerts();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create alert');
    }
  };

  const deleteAlert = async (id) => {
    try {
      await alertApi.delete(id);
      fetchAlerts();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to delete alert');
    }
  };

  const toggleAlert = async (id, isActive) => {
    try {
      await alertApi.update(id, { is_active: !isActive });
      fetchAlerts();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to update alert');
    }
  };

  return {
    alerts,
    loading,
    error,
    createAlert,
    deleteAlert,
    toggleAlert,
    refresh: fetchAlerts,
  };
}
